export const FRONT_URL = process?.env?.REACT_APP_FRONT_BASE_URL || 'https://telltail.com'